import { getCompanies } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const COMPANY_LIST = "COMPANY_LIST";

export function useCompanyListQuery() {
	return useQuery({
		queryKey: [COMPANY_LIST],
		queryFn: processResponse(() => getCompanies()),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
	});
}
